
import React, { useEffect, useMemo, useState } from 'react';

import useFilterForCheckbox from '../hooks/useFilterForCheckbox';

import FilterItem from './FilterItem';

/**
 * FilterAuthorLastInitial
 *
 * A filter that returns author last names starting with a letter of the alphabet
 *
 * @param {Object} props
 * @param {Object} props.context
 * @param {Object} props.setStart
 * @param {string} props.dataCode
 * @param {Object} props.scrollToTop
 */
const FormatFilter = ({ context, setStart, dataCode, scrollToTop }) => {
  const [ isActive, setIsActive ] = useState( false );
  const [ data, setData ] = useState( [] );
  const formats = JSON.parse( context?.selectedFormats );

  const {
    checked,
    setChecked,
    handleFilter
  } = useFilterForCheckbox( setStart, dataCode, scrollToTop );

  useEffect( () => {
    const setupRequest = async() => {
      const baseUrl = window.location.origin;
      const body = JSON.stringify({ rows: 0 });
      const ajaxNonce = typeof ajax_object !== 'undefined' ? ajax_object.nonce : null;

      const response = await fetch( `${baseUrl}/wp-json/dwt/v2/list-format`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          // eslint-disable-next-line camelcase, no-undef
          'X-WP-Header': ajaxNonce
        },
        body
      });

      const responseData = await response.json();
      return responseData;
    };

    ( async() => {
      await setupRequest()
        .then( ( response ) => {
          // console.log(response);
          setData( response.data.formats );
        })
        .catch( ( error ) => {
          console.error( error );
        })
        .finally( () => {

        });
    })();
  }, [] );

  useMemo( () => {
    return data.forEach( ( item ) => {
      item.value = item.code;
      item.label = item.desc;

      delete item._embeds;
      delete item._links;
      delete item.code;
      delete item.desc;
    });
  }, [ data ] );

  useEffect( () => {
    const consolidate = {
      CD: 'Compact Disc',
      DN: 'Audio Download',
      HC: 'Hardcover',
      NT: 'Other',
      TR: 'Trade Paperback',
      DG: 'Digest',
    };

    data.forEach( ( item ) => {
      for ( const [ key, value ] of Object.entries( consolidate ) ) {
        if ( item.value.includes( key ) ) {
          item.label = value;
        }
      }
    });
  }, [ data ] );

  const uniqueFormatData = data.filter( ( obj, index ) => index === data.findIndex( o => obj.value === o.value ) );
  const matchFormatData = uniqueFormatData?.map( ( item ) => formats.includes( item.value ) ? item : null ).filter( ( filteredItem ) => filteredItem !== null );

  return (
    matchFormatData.length > 0 && (
      <FilterItem
        data={ matchFormatData }
        setStart={ setStart }
        dataCode="data-format-codes"
        title="Format"
        isActive={ isActive }
        setIsActive={ setIsActive }
        checked={ checked }
        setChecked={ setChecked }
        handleFilter={ ( e, index ) => handleFilter( e, index ) }
        scrollToTop={ scrollToTop }
      />
    )

  );
};

export default FormatFilter;
